export class FormWizardTemplate {
    constructor() {
        this.label = '';
        this.description = '';
        this.rightSectionHtml = '';
        this.pages = [];
    }

    label: string;
    description: string;
    rightSectionHtml: string;
    pages: Array<FormWizardPage>;
}

export class FormWizardPage {
    constructor() {
        this.label = '';
        this.previousButtonLabel = 'Previous';
        this.nextButtonLabel = 'Next';
        this.completeButtonLabel = '';
        this.completeButtonClasses = 'button-primary';
        this.elements = [];
    }

    label: string;
    previousButtonLabel: string;
    nextButtonLabel: string;
    completeButtonLabel: string;
    completeButtonClasses: string;
    elements: Array<FormWizardPageElement>;
}

export class FormWizardPageElement {
    constructor() {
        this.type = '';
        this.name = '';
        this.label = '';
        this.class = '';
        this.required = false;
    }

    type: string;
    name: string;
    label: string;
    pattern: string | undefined;
    mask: string | undefined;
    class: string;
    required: boolean;
    defaultValue: string | undefined;
    placeholder: string | undefined;
    maxValue: object | undefined;
    values: Array<object> | undefined;
    valueField: string | undefined;
    nameField: string | undefined;
    valueFields: Array<FormWizardPageElementValueField> | undefined;
    defaultSearchCountry: string | undefined;
    validatorFunction: any;
}

export class FormWizardPageElementValueField {
    constructor() {
        this.name = '';
        this.field = '';
    }

    name: string;
    field: string;
}
